exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autoLogin[data-v-e23d1282]{position:absolute;height:100vh;width:100vw;top:0;left:0;background:#fff!important;padding:.3rem}.autoLogin>div[data-v-e23d1282]{width:4rem;height:1.6rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}.autoLogin>div .login-loading[data-v-e23d1282]{width:1.6rem;height:1.6rem;margin:0 auto}.autoLogin>div p[data-v-e23d1282]{line-height:1rem;font-size:.28rem;color:#409eff}", ""]);

// exports
